var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.659,
    height: 19.658,
    viewBox: "0 0 19.659 19.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1a1818;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.394,18.131a14.62,14.62,0,0,0-3.054-2.044c-.915-.44-1.251-.43-1.9.036-.539.39-.888.752-1.509.616A9,9,0,0,1,11.9,14.5a8.937,8.937,0,0,1-2.243-3.031c-.131-.625.231-.97.616-1.509.467-.648.48-.983.036-1.9A14.331,14.331,0,0,0,8.266,5c-.666-.666-.816-.521-1.183-.39A6.73,6.73,0,0,0,6,5.19,3.267,3.267,0,0,0,4.7,6.563c-.258.557-.557,1.6.965,4.3A24.02,24.02,0,0,0,9.889,16.5h0l0,0,0,0h0a24.114,24.114,0,0,0,5.632,4.223c2.71,1.523,3.747,1.223,4.3.965a3.211,3.211,0,0,0,1.373-1.3,6.73,6.73,0,0,0,.575-1.083C21.915,18.947,22.064,18.8,21.394,18.131Z",
    transform: "translate(-1.397 -5.083) rotate(8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/phone_logo.542e11b672dd7f562aeaa2f83ebfd902.svg";
export { ForwardRef as ReactComponent };